// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"xZ-z","sponsoredTooltipWrapper":"yZ-z","sponsoredTooltip":"zZ-z","newCard":"AZ-z"};